import { 
  ErrorsCallback,
  Success,
    LoadingClose
  } from "./alertService"
import Auth from "auth"

import ConfigHost from "./ConfigHost"
import request from "request" 
var Authorization = Auth.getUserToken()
export const APIGet = (
  URL,
  callBackSuccess,
  callBackError, 
  isAnotherHost = false
) => {
  request({
    headers: {
      "Authorization": Authorization,  
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
    },
    uri: isAnotherHost ? URL:ConfigHost.HOST_API + URL,
    method: 'GET'
  }, function (error, response, body) {
    // console.log('error:', error); // Print the error if one occurred
    // console.log('statusCode:', response && response.statusCode); // Print the response status code if a response was received
    // console.log('body:', body); // Print the HTML for the Google homepage.

    if ((body != undefined || body != null) && response.statusCode === 200) {
      var responseData = JSON.parse(body)
      if (responseData && responseData.success) {
        APIMiddlewareSuccess(responseData, callBackSuccess)
      } else {
        APIMiddlewareErrors(URL, responseData, callBackError)
      }
    } else {
        APIMiddlewareErrorsSystems(URL, response, error, callBackError)
    }

  });
}

export const APIPost = (
  URL,
  JsonDatas,
  callBackSuccess,
  callBackError,
  isAnotherHost = false
) => {

  // request.post({ url: ConfigHost.HOST_API + URL, form: JsonDatas }, function (error, response, body) {
  request.post({
    headers: {
      "Authorization": Authorization,  
      'Content-Type': 'application/x-www-form-urlencoded', 
      'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
    },
    uri: isAnotherHost ? URL:ConfigHost.HOST_API + URL,
    method: 'POST'
    , form: JsonDatas
  }, function (error, response, body) {

    // console.log('error:', error); // Print the error if one occurred
    // console.log('statusCode:', response && response.statusCode); // Print the response status code if a response was received
    // console.log('body:', body); // Print the HTML for the Google homepage.

    if ((body != undefined || body != null) && response.statusCode === 200) {
      var responseData = JSON.parse(body)
      if (responseData && responseData.success) {
        APIMiddlewareSuccess(responseData, callBackSuccess)
      } else {
        APIMiddlewareErrors(URL, responseData, callBackError)
      }
    } else {
      APIMiddlewareErrorsSystems(URL, response, error, callBackError)
    }
  })
}

function APIMiddlewareSuccess(datas, callBackSuccess) {
  // console.log("API Response Success >>> ", datas);
  if (datas.middlewareAlart) {
    //LoadingClose()
    Success(datas.message)
  }
  if (callBackSuccess) {
    callBackSuccess(datas)
  }
}
function APIMiddlewareErrors(url, responseData, callBackError) {

  var middlewareAlart = responseData.middlewareAlart
  if (middlewareAlart) {
    var errTxt = ""
    if(responseData.errors && responseData.errors.errors){
      // responseData.errors.errors.forEach(element => {
      //   errTxt +=  " " + element.message
      // });
      for (const key in responseData.errors.errors) {
        if (responseData.errors.errors.hasOwnProperty(key)) {
          const element = responseData.errors.errors[key];
          errTxt +=  " " + element.message
        }
      }
    }
    LoadingClose()
    ErrorsCallback(
      responseData.message + " : " + errTxt,
      // url + " : " + responseData.message + " : " + errTxt,
      () => {
        const arr_status_logout = [101, 100, 99]
        if (arr_status_logout.indexOf(responseData.status) >= 0) {
          Auth.destroyAuthentication()
          window.location.reload() 
          return
        }
      }
    )
  }
  if (callBackError) {
    callBackError(responseData)
    return
  }
}
function APIMiddlewareErrorsSystems(url, responseData, error, callBackError) {
  if (responseData) {
    LoadingClose()
    ErrorsCallback(
      "Status is " + responseData.statusCode + " : " + responseData.statusMessage,
      null
    )
  } else {
    ErrorsCallback(
      url + " : " + error,
      null
    )
  }
  if (callBackError) {
    callBackError(responseData)
    return
  }

}
